import { useDispatch } from 'react-redux';
import { Label } from '../../../../../../../common/labels/labelTypes';
import { useCallback, useEffect, useState } from 'react';
import {
    clearTemporaryLabelColorStyles,
    setTemporaryLabelColorStyles,
} from '../../colorTools/setTemporaryLabelColorStyles';
import { getColorDefaultHexValue, getColorToPersist } from '../../../../../../../common/colors/elementColorFormatUtil';
import { updateLabel } from '../../../../../../../common/labels/labelActions';
import { DEFAULT_ELEMENT_COLOR } from '../../../../../../../common/colors/colorConstants';

export type LabelColorHandlerReturnType = {
    handleTempColorChange: (color: string | null) => void;
    handleColorChange: (color: string | null) => void;
    tempColor: string | null;
    setTempColor: (color: string | null) => void;
    clearPreview: () => void;
    selectedColor: string | undefined;
    selectedColorHex: string;
};

export const useLabelColorHandler = (label: Label | undefined): LabelColorHandlerReturnType => {
    const dispatch = useDispatch();
    const [tempColor, setTempColor] = useState<string | null>(null);

    useEffect(() => {
        setTempColor(null);

        return () => {
            if (!label?._id) return;

            clearTemporaryLabelColorStyles(label._id);
        };
    }, [label?._id]);

    const handleTempColorChange = (color: string | null) => {
        if (!label || !color) return;

        setTempColor(color);
        setTemporaryLabelColorStyles(label._id, color);
    };

    const handleColorChange = (color: string | null) => {
        if (!label) return;

        const colorToSave = getColorToPersist(color);
        dispatch(updateLabel(label._id, { color: colorToSave ?? undefined }));
        clearTemporaryLabelColorStyles(label._id);
        setTempColor(null);
    };

    const clearPreview = useCallback(() => {
        if (!label?._id) return;

        clearTemporaryLabelColorStyles(label._id);
        setTempColor(null);
    }, [label]);

    const selectedColor = tempColor ?? label?.color;
    const selectedColorHex = getColorDefaultHexValue(selectedColor ?? DEFAULT_ELEMENT_COLOR);

    return {
        handleTempColorChange,
        handleColorChange,
        tempColor,
        setTempColor,
        clearPreview,
        selectedColor,
        selectedColorHex,
    };
};
